import React, {Suspense, useEffect, useState} from 'react';

import type {SmoothScrollbarProps} from "./SmoothScrollbar";
import DroowMenu from "../components/header/menu/DroowMenu";
import LoadingPage from "../hooks/LoadingPage";
import runWhenIdle from "../utils/runWhenIdle";

const MainScrollBar = React.lazy(() => import("./MainScrollBar"));
const CustomCursor = React.lazy(() => import("./CustomCursor"));


interface LayoutProps extends SmoothScrollbarProps {
    tag?: React.ElementType,
    activeScrollbar?: boolean
}

function Layout(
    {className, children, tag: Tag = "div", activeScrollbar, ...restProps}: LayoutProps) {
    const [showCursor, setShowCursor] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined")
            return;

        const canHover = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
        if (!canHover)
            return;

        let cancelled = false;
        const cancelIdle = runWhenIdle(() => {
            if (!cancelled)
                setShowCursor(true);
        }, {timeout: 2000});

        return () => {
            cancelled = true;
            cancelIdle();
        };
    }, []);

    return (
        <Tag id="main_layout" className={className}>
            <DroowMenu hamburger/>
            <LoadingPage/>
            {activeScrollbar ? (
                <Suspense fallback={children}>
                    <MainScrollBar  {...restProps}>{children}</MainScrollBar>
                </Suspense>
            ) : children}
            {showCursor && (
                <Suspense fallback={null}>
                    <CustomCursor
                        duration={0.5}
                        durationChangeSize={0.3}
                        size={30}
                        scale={75}
                        ease="power2.out"
                    />
                </Suspense>
            )}
        </Tag>
    );
}

export default Layout;
